export const StorageAreasColums = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 40,
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "时间",
    dataIndex: "placeholder",
    key: "placeholder",
  },
  {
    title: "库区类型",
    dataIndex: "placeholder",
    key: "placeholder",
  },
  {
    title: "库位",
    dataIndex: "placeholder",
    key: "placeholder",
  },
  {
    title: "到仓时间",
    dataIndex: "placeholder",
    key: "placeholder",
  },
  {
    title: '批次号',
    dataIndex: 'placeholder',
    key: 'placeholder',
  },
  {
    title: 'SKU',
    dataIndex: 'placeholder',
    key: 'placeholder',
  },
  {
    title: '数量',
    dataIndex: 'placeholder',
    key: 'placeholder',
  },
  {
    title: '类型',
    dataIndex: 'placeholder',
    key: 'placeholder',
  },
  {
    title: '上架操作人',
    dataIndex: 'placeholder',
    key: 'placeholder',
  },
];
